export default __webpack_public_path__ + "static/media/a012-market-line-3.74685c40.svg";